export const SITE_MAX_WIDTH = '70.25rem';
export const SITE_MAX_WIDTH_PX = 1124;
